<template>
  <div class="golf-page-outer">
    <div :class="['golf-outer', dataReady ? 'loaded' : '']" class="for-max-width-measure">
      <div class="home-page">
        <div class="row">
          <div :class="[showData ? 'show-data' : '']"
            class="col-md-6 col-xs-6 golf-background-image mobile-view">
            <div class="golf-text">
              <h4>Vel gert {{fullName}}, þú gætir verið á leiðinni til Montecastillo</h4>
              <div class="golf-player-img">
                <img src="/static/images/banner.png" alt="Vörður"/>
              </div>
            </div>
            <p class="golf-inner-text">
             Við drögum út vinningshafa á Facebook síðu Varðar þann 15. ágúst 2019. Nú er vissara að fylgjast með á síðunni okkar.</p>
            <div class="mobile-button">
              <button type="button" v-on:click="showData = !showData">Áfram</button>
            </div>
          </div>
          <div class="col-md-6" :class="[!showData ? 'show-content' : '']">
            <div class="clubs-page">
              <div class="status-image desktop-view">
                <svg><use xlink:href="#status-bar-img"></use></svg>
                <p class="text-line">{{fullName}}</p>
              </div>
              <h3>Takk fyrir að taka þátt</h3>
              <p class="club-text">Nú getur þú reynt fyrir þér á æfingasvæðinu eða þá tekið annan hring og reynt að bæta skorið.</p>
              <div class="club-detail-img">
                <svg><use xlink:href="#club-detail-img"></use></svg>
              </div>
              <div v-if="this.$data.globalData.user.user_club">
                <p class="club-middle-text">Þú stóðst þig vel fyrir klúbbinn og safnaðir</p>
                <p v-if="userTotalPoints" class="user-points">{{userTotalPoints}}   punktum</p>
                <div class="see-all-clubs">
                  <a href="/list/" title="Rules">
                   <div class="arrow-img">
                      <svg><use xlink:href="#arrow"></use></svg>
                    </div>
                    <div class="see-clubs"> Sjá alla klúbba 
                    </div>
                  </a>
                </div>
              </div>
              <div id="app"></div>
            </div>
          </div>
          <div class="col-md-6 golf-image desktop-view">
            <div class="golf-text">
              <h4>Vel gert {{fullName}}, þú gætir verið á leiðinni til Montecastillo</h4>
              <p class="image-text">Við drögum út vinningshafa á Facebook síðu Varðar þann 15. ágúst 2019. Nú er vissara að fylgjast með á síðunni okkar.</p>
              <div class="golf-player">
                <img src="/static/images/banner.png" alt="Vörður"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/shared/api'
export default {
  name: 'ClubDetail',
  data () {
    return {
      clubList: null,
      clubImage: null,
      userTotalPoints: null,
      fullName: null,
      dataReady: false,
      showLoader: false,
      showData: false
    }
  },
  created () {
    this.getClubList()
    if (this.$data.globalData && this.$data.globalData.user && this.$data.globalData.user.user_total_points) {
      this.userTotalPoints = this.$data.globalData.user.user_total_points
    }
    if (this.$data.globalData.user) {
      this.fullName = this.$data.globalData.user.name
      if (this.$data.globalData.user.user_club) {
        this.clubImage = this.$data.globalData.user.user_club.image_url
      }
    }
  },
  methods: {
    getClubList () {
      API.meInstance.get('/clubs/').then((res) => {
        this.clubList = res.data.data
        this.dataReady = true
        this.showLoader = false
      }).catch((error) => {
        console.log('Error loading', error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.see-all-clubs {
  padding-top: 25px
}
.see-clubs {
  color: #4B4B4A;
  font-size: 18px;
  display: inline-flex;
  padding-left: 5px;
}
.arrow-img {
  display: inline-flex;
  padding-right: 5px;
  svg {
    width: 51px;
    height: 8px;
  }
}
.play-again {
  cursor: pointer;
}
.club-detail-img {
  svg {
    width: 392px;
    height: 160px;
  }
}
.club-detail-btn {
  button {
    vertical-align: middle;
    display: inline-block;
    font-size: 18px;
    padding: 11px 30px 9px 30px !important;
  }
  .free-play-btn {
    margin-right: 5px;
  }
  .play-again {
    margin-left: 5px;
  }
}
.club-middle-text {
  font-size: 16px;
  padding-top: 25px;
}
.rules-text {
  position: absolute;
  transform: rotate(-90deg);
  left: -10px;
  top: 190px;
  color: #696865;
  font-size: 18px;
  .arrow-img {
    left: -60px;
    position: absolute;
    top: -1px;
    svg {
      width: 51px;
      height: 8px;
    }
  }
}
.row {
  margin-left: 0;
  margin-right: 0;
}
.continue-button {
  padding: 90px;
  button {
    padding: 0 10px;
  }
}
.greetings-inner {
  text-align: center;
}
.greetings-text {
  padding: 100px;
}
.share-button {
  padding-top: 25px;
}
.see-clubs-button {
  text-align: center;
  padding-top: 8px;
  button {
    color: #4B4B4A;
    font-size: 18px;
  }
}
.club-detail-inner {
  padding: 25px 0;
}
h3 {
  color: #696865;
  font-size: 24px;
}
.club-text {
  color: #696865;
  padding: 0 10px;
  font-size: 16px;
}
.clubs-page {
 padding: 50px 75px;
}
.flag-image {
  padding-top: 10px;
}
.golf-text {
  background-image: url('/static/images/ground.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 800px;
  position: relative;
  .golf-player {
    position: absolute;
    right: 0;
    bottom: -100px;
    height: 580px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
h4,.image-text   {
  font-size: 48px;
  color: #FFFFFF;
  margin: 0;
  text-align: left;
  padding: 50px;
}
.image-text {
  font-size: 20px;
  padding: 0 125px 0 50px;
}
.flag-image {
  width: 68px;
  height: 92px;
  margin: 0 auto;
}
.inlineBlock {
  display: none !important;
}
.golf-background-image {
  .golf-text  {
    height: 430px;
    box-shadow: 0px 4px 100px rgba(0, 0, 0, 0.15);
    h4 
    {
      padding: 30px;
      font-size: 25px;
      padding-top: 100px;
    }
  }
  .golf-player-img {
    position: absolute;
    text-align: right;
    bottom: -70px;
    height: 410px;
    width: 350px;
    right: 0;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.golf-inner-text {
  font-size: 18px;
  color: #696865;
  padding: 25px;
  padding-top: 40px;
}
.show-data {
  display: none;
}
@media(max-width: 1200px) {
  .show-data,.show-content {
    display: none;
  }
}
</style>
